import { styled } from '@mui/material'

import { BaseContainer } from '../../config/styles/BaseGrid'

export const Logo = styled('img')`
  height: auto;
  min-width: 200px;
  pointer-events: none;
  user-select: none;
`

export const LogoLink = styled('a')`
  cursor: pointer;
  display: flex;
`

export const Root = styled(BaseContainer)``
